// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:54:12.154Z
// Property: Woodbridge Apartments (ID: 6767906449166916)
// Collections: 22 amenities, 3 floorplans (live), 45 photos, 42 POIs, 2 reviews, 7 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166916",
  "property_external_id": "495844",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/woodbridge-apartments-sacramento-ca/g6rwzhx/",
  "property_google_business_url": "https://www.google.com/maps/place/Woodbridge+Apartments/data=!4m2!3m1!1s0x0:0x85a0418bfcd60ca4?sa=X&ved=2ahUKEwj_nauRoLySAxVdlmoFHW5gC8wQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495844 p0505512",
  "property_status": null,
  "property_slug": "woodbridge-apartments",
  "property_name": "Woodbridge Apartments",
  "property_website_url": "https://www.sacramento-california-apartments.com/",
  "property_domain": "https://www.sacramento-california-apartments.com/",
  "property_address": "2028 San Juan Road",
  "property_full_address": "2028 San Juan Rd, Sacramento, CA 95833",
  "property_address_1": "2028 San Juan Road",
  "property_address_2": null,
  "property_address_city": "Sacramento",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95833",
  "property_address_country": "US",
  "property_address_county": "Sacramento County",
  "property_neighborhood_address": "North Sacramento",
  "property_address_latitude": "38.6265656",
  "property_address_longitude": "-121.5070985",
  "property_email": "woodbridge@ctlmanagement.com",
  "property_phone": "(279) 239-2780",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Woodbridge Apartments in sunny Sacramento, CA, where modern living meets comfort. Choose from spacious one- or two-bedroom floor plans, and enjoy amenities like a sparkling pool, fitness center, and tennis court. Find your perfect home today—check our availability or schedule a tour to experience the lifestyle you deserve!",
  "property_long_description": "**Welcome to Woodbridge Apartments – Your Ideal Home in Sacramento, CA!**\n\nDiscover the perfect blend of comfort and convenience at Woodbridge Apartments, where a variety of floor plans await your arrival. Choose from our spacious One Bedroom and Two Bedroom options, each designed to cater to your lifestyle. Explore our community and enjoy a range of exceptional amenities that redefine apartment living.\n\nDive into relaxation at our shimmering pool or unwind at the spa after a workout in our fully-equipped fitness center. Your little ones can enjoy endless fun at the playground while you take advantage of our convenient online services, laundry facilities, and high-speed internet access. For outdoor enthusiasts, our picturesque sundeck, picnic area, and well-maintained tennis court provide ample opportunities for leisure and relaxation.\n\nOur thoughtfully designed apartments feature walk-in closets, comfortable carpeting, and cozy fireplaces, with many units offering stunning views. Each home is equipped with essential amenities, including a balcony, washer/dryer, and smoke-free living options. We also prioritize accessibility, with wheelchair-accessible rooms available to ensure everyone feels at home.\n\nCommuters will appreciate the easy access to public transportation, making it simple to explore nearby attractions in Sacramento. With additional conveniences such as storage space, linen closets, and cable-ready connections, you’ll have everything you need and more.\n\nDon’t miss out on the opportunity to join our vibrant community. Find your new home today—browse our availability or schedule a tour to visit Woodbridge Apartments and experience all we have to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019db197-c8b4-7398-a77f-1f014c59c393.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
    "public_id": "019db197-c8b4-7398-a77f-1f014c59c393",
    "storage_key": "property/6767906449166916/019db197-c8b4-7398-a77f-1f014c59c393.webp",
    "width": 1920,
    "height": 972
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "301",
  "property_year_built": "1986",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.67441860465115",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $500-600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Maximum Number of Pets: 2 (Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old)\nMaximum Weight Limit: 25 pounds\nMonthly Pet Rent: $30 per pet",
  "property_online_leasing_url": "https://sacramento-california-apartments.securecafe.com/onlineleasing/woodbridge/guestlogin",
  "property_resident_portal_url": "https://sacramento-california-apartments.securecafenet.com/residentservices/woodbridge/userlogin",
  "property_apply_now_url": "https://sacramento-california-apartments.securecafe.com/onlineleasing/woodbridge/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d7418-bb19-7343-8ca1-5f7e783f6d99.webp",
  "property_primary_logo_media": {
    "alt_text": "Woodbridge Apartments logo",
    "public_id": "019d7418-bb19-7343-8ca1-5f7e783f6d99",
    "storage_key": "property/6767906449166916/019d7418-bb19-7343-8ca1-5f7e783f6d99.webp",
    "width": 639,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d7418-ba54-70db-81cc-0e5016df9e6b.webp",
  "property_secondary_logo_media": {
    "alt_text": "Woodbridge Apartments logo.",
    "public_id": "019d7418-ba54-70db-81cc-0e5016df9e6b",
    "storage_key": "property/6767906449166916/019d7418-ba54-70db-81cc-0e5016df9e6b.webp",
    "width": 619,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019de0b2-5282-7258-837c-93a9104ad417.webp",
  "property_mono_white_logo_media": {
    "alt_text": "White horizontal bar with black bars above and below",
    "public_id": "019de0b2-5282-7258-837c-93a9104ad417",
    "storage_key": "property/6767906449166916/019de0b2-5282-7258-837c-93a9104ad417.webp",
    "width": 639,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019de0b2-4687-74ec-903d-624e7c69bdfc.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black rectangle graphic",
    "public_id": "019de0b2-4687-74ec-903d-624e7c69bdfc",
    "storage_key": "property/6767906449166916/019de0b2-4687-74ec-903d-624e7c69bdfc.webp",
    "width": 639,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#FAAD45",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "655 - 765",
  "property_sqft_min": "655",
  "property_sqft_max": "765",
  "property_price_range": "1555 - 2330",
  "property_price_min": "1555",
  "property_price_max": "2330",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/woodbridgeapartmenthomes/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJk1Q3dVvWmoARpAzW_ItBoIU",
  "property_youtube_url": "https://www.youtube.com/watch?v=CP5vq4smLLw",
  "property_yelp_url": "https://www.yelp.com/biz/point-natomas-apartments-sacramento-2",
  "property_tiktok_url": "https://www.tiktok.com/@sacramentobrian/video/7525136084662095134",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Woodbridge Apartments",
  "property_home_romance_title": "Find Your Forever Home in Our Enchanting Apartment Community",
  "property_home_amenities_blurb": "Welcome to Woodbridge Apartments in sunny Sacramento, CA, where comfort meets convenience. Choose from our stylish one or two-bedroom floor plans, each designed for modern living. Enjoy amenities like a refreshing pool, a state-of-the-art fitness center, and serene picnic areas, all set in a smoke-free environment designed for your lifestyle.",
  "property_home_floorplans_blurb": "Welcome to Woodbridge Apartments in sunny Sacramento, CA, where elegance meets comfort. Our thoughtfully designed floor plans cater to every lifestyle, offering spacious interiors and modern finishes. Browse our available apartment homes today to discover your ideal living space, perfect for creating unforgettable memories in a thriving community.",
  "property_home_gallery_blurb": "At Woodbridge Apartments in Sacramento, CA, your ideal home awaits! Choose from spacious one and two-bedroom floor plans, complemented by resort-style amenities like a shimmering pool, a state-of-the-art fitness center, and scenic picnic areas. Picture yourself enjoying the balcony views and cozy evenings by the fireplace.",
  "property_home_neighborhood_blurb": "Welcome to Woodbridge Apartments, where vibrant city life meets comfort and convenience in Sacramento, CA. Choose from spacious one and two-bedroom floor plans, and enjoy a community surrounded by parks, boutique shopping, cultural attractions like the California State Capitol Museum, and local hotspots such as the Sacramento Zoo and Golden 1 Center.",
  "property_home_reviews_blurb": "Welcome to Woodbridge Apartments in Sacramento, where residents rave about the “welcoming atmosphere and stunning amenities.” Experience the perfect blend of comfort and community. Ready to envision your lifestyle here? See what our residents have to say about living at our community! Your new home awaits.",
  "property_neighborhood_blurb": "At Woodbridge Apartments in Sacramento, immerse yourself in a vibrant neighborhood filled with culture, convenience, and community. Enjoy easy access to charming parks, the California State Capitol Museum, and the engaging exhibits at the California State Railroad Museum. Uncover local favorites and everything our lively area has to offer!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Woodbridge Apartments in Sacramento, indulge in a lifestyle enhanced by a sparkling pool, state-of-the-art fitness center, and inviting sundeck. Our spacious one and two-bedroom floor plans boast modern comforts, including walk-in closets and high-speed internet. Embrace relaxation with a fireplace, spa, and nearby playgrounds, all in a smoke-free environment.",
  "property_applynow_blurb": "At Woodbridge Apartments in Sacramento, your ideal living space awaits. Choose from spacious one- and two-bedroom layouts, featuring serene balconies and walk-in closets. Enjoy top-notch amenities like a refreshing pool, fitness center, and tennis courts—all designed for comfort and convenience. Seize your chance to elevate your lifestyle and lease online today!",
  "property_contactus_blurb": "At Woodbridge Apartments in Sacramento, CA, your ideal living space awaits. Choose from our thoughtfully designed one and two-bedroom floor plans tailored for comfort and style. Need assistance? Our friendly leasing team is just a call away—reach out today and let us help you find your perfect home!",
  "property_faqs_blurb": "At Woodbridge Apartments in Sacramento, CA, our diverse floor plans—whether you crave a cozy one-bedroom or spacious two-bedroom—are designed for your lifestyle. Curious about life in our community? Dive into our FAQs page for insights and answers tailored to enhance your living experience.",
  "property_floorplans_blurb": "At Woodbridge Apartments in Sacramento, CA, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. With spacious layouts and modern amenities, each home invites comfort and convenience. Browse our available apartment homes today and find the ideal floor plan that suits your unique needs!",
  "property_gallery_blurb": "At Woodbridge Apartments in Sacramento, CA, vibrant living meets modern comfort. From spacious one and two-bedroom floor plans to amenities like a sparkling pool, state-of-the-art fitness center, and serene picnic area, our community invites you to picture yourself enjoying life’s best moments. Your perfect home awaits—browse our photo gallery today!",
  "property_interactivemap_blurb": "Welcome to Woodbridge Apartments in Sacramento, CA, where comfort meets convenience. Choose from spacious one- and two-bedroom floor plans featuring amenities like a refreshing pool, well-equipped fitness center, and serene sundeck. Elevate your lifestyle with our interactive community map to find your perfect home today!",
  "property_pets_blurb": "Nestled in the heart of Sacramento, Woodbridge Apartments offers a welcoming haven for both you and your furry companions. With a relaxed pet policy accommodating indoor cats and dogs up to 25 lbs, your pets can thrive alongside you in style. Enjoy spacious living infused with comfort and charm.",
  "property_referafriend_blurb": "At Woodbridge Apartments in Sacramento, CA, life thrives in stylish one and two-bedroom homes designed for comfort and connection. Share the experience—great friends make great neighbors! Refer a friend today and let them join our vibrant community, where quality living meets lasting friendships.",
  "property_residentaccess_blurb": "Welcome to Woodbridge Apartments in sunny Sacramento, CA, where comfort meets convenience. Our thoughtfully designed one and two-bedroom floor plans provide a perfect sanctuary. Access your resident portal to effortlessly pay rent, schedule maintenance, and stay connected with your community. Experience hassle-free living at Woodbridge today!",
  "property_reviews_blurb": "At Woodbridge Apartments in Sacramento, residents rave about the vibrant community atmosphere, saying, “The friendly neighbors and exceptional amenities truly make this place feel like home.” Dive into our reviews to hear more firsthand experiences that highlight the charm and convenience of life in our exceptional community!",
  "property_created_at": "1762785279030",
  "property_scheduletour_blurb": "At Woodbridge Apartments in Sacramento, CA, find your ideal space with our thoughtfully designed one and two-bedroom floor plans. Experience the perfect blend of comfort and style while enjoying a vibrant community. Curious about life here? Check out resident testimonials and see why they love calling Woodbridge home!",
  "property_thankyou_blurb": "Thank you for reaching out! At Woodbridge Apartments in Sacramento, CA, we offer a blend of comfort and modern living with our thoughtfully designed one and two-bedroom floor plans. A member of our friendly team will connect with you soon to help you find your perfect home!",
  "property_virtualtours_blurb": "Step inside Woodbridge Apartments, where modern elegance meets comfort in the heart of Sacramento, CA. Choose from our thoughtfully designed one- and two-bedroom floor plans that suit your lifestyle. Ready to envision your new home? Immerse yourself in a virtual tour of our inviting community and apartments for rent!",
  "property_copyright": "2025 All Rights Reserved. Woodbridge Apartments",
  "property_seo_title_home": "Woodbridge Apartments |  Apartments in Sacramento, CA",
  "property_seo_description_home": "Welcome to Woodbridge Apartments in Sacramento, CA! Enjoy a lifestyle with stunning amenities, from a pool to a fitness center. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | Sacramento, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Woodbridge Apartments in Sacramento! Our one and two-bedroom floor plans offer comfort and style—browse today to see your future home!",
  "property_seo_title_amenities": "Amenities | Sacramento, CA Apartments for Rent",
  "property_seo_description_amenities": "Experience the perfect blend of comfort and convenience at Woodbridge Apartments in Sacramento. Dive into luxury with our pool, gym, and stunning views!",
  "property_seo_title_gallery": "Gallery | Apartments in Sacramento, CA",
  "property_seo_description_gallery": "Step into serenity at Woodbridge Apartments in Sacramento. With stunning views, a refreshing pool, and top-notch amenities, picture your perfect life here!",
  "property_seo_title_virtualtours": "Virtual Tours | Woodbridge Apartments Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Woodbridge Apartments in Sacramento! Take a virtual tour of our stylish one and two-bedroom homes tailored for modern living.",
  "property_seo_title_interactivemap": "Interactive Map | Woodbridge Apartments Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Woodbridge Apartments! Enjoy pools, fitness, and amenities in Sacramento, CA. Use our map to explore available listings and pricing!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Sacramento, CA",
  "property_seo_description_neighborhood": "Uncover the charm of Sacramento at Woodbridge Apartments! From trendy cafes to parks, dive into the vibrant neighborhood surrounding your future home.",
  "property_seo_title_contact": "Contact Us | Woodbridge Apartments",
  "property_seo_description_contact": "Reach out to the Woodbridge Apartments leasing team in Sacramento, CA! Inquire about our one and two-bedroom floor plans and find your perfect home today.",
  "property_seo_title_faqs": "FAQs | Apartments in Sacramento, CA",
  "property_seo_description_faqs": "Discover Woodbridge Apartments in Sacramento—your guide to spacious floor plans, great amenities, and a vibrant community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Sacramento, CA",
  "property_seo_description_reviews": "Experience life at Woodbridge Apartments in Sacramento! Enjoy modern amenities, spacious floor plans, and vibrant resident reviews. Join our community today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Sacramento, CA",
  "property_seo_description_applynow": "Discover serene living at Woodbridge Apartments, Sacramento! Enjoy premium amenities, spacious layouts, and easy online leasing. Your perfect home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Woodbridge Apartments",
  "property_seo_description_residentaccess": "Log in to your Woodbridge Apartments resident portal in Sacramento, CA. Pay rent, schedule maintenance, and manage your home all in one convenient place!",
  "property_seo_title_referafriend": "Refer A Friend | Woodbridge Apartments",
  "property_seo_description_referafriend": "Refer a friend to Woodbridge Apartments in Sacramento! Great friends make great neighbors—share the experience of our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Woodbridge Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Woodbridge Apartments in Sacramento. Schedule a tour today and step into your future home surrounded by comfort and convenience!",
  "property_seo_title_privacy": "Privacy Policy | Woodbridge Apartments",
  "property_seo_description_privacy": "At Woodbridge Apartments, your privacy matters. Discover how we protect your information while you enjoy comfortable living in Sacramento!",
  "property_seo_title_accessibility": "Website Accessibility | Woodbridge Apartments",
  "property_seo_description_accessibility": "At Woodbridge Apartments in Sacramento, we prioritize accessibility for all. Join our community where comfort meets inclusivity—your ideal home awaits!",
  "property_seo_title_sitemap": "Sitemap | Woodbridge Apartments",
  "property_seo_description_sitemap": "Navigate your way to a vibrant life at Woodbridge Apartments in Sacramento, CA. Check out our sitemap to discover everything our community has to offer!",
  "property_seo_title_thankyou": "Thank You | Woodbridge Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to comfortable living at Woodbridge Apartments in Sacramento begins here—expect a friendly response soon.",
  "property_seo_title_pets": "Pet Policy | Apartments in Sacramento, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778874759538",
  "amenities": [
    {
      "id": "ec_edec07840eb1f1ef33165342",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429654",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d42af-800c-777b-bd14-41d979061295.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with cardio machines, weight training equipment, and a punching bag.",
        "public_id": "019d42af-800c-777b-bd14-41d979061295",
        "storage_key": "property/6767906449166916/019d42af-800c-777b-bd14-41d979061295.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Fitness Center Equipment at Woodbridge Apartments, CA 95833,Fitness Center Equipment & Exit at Woodbridge Apartments, California, 95833,Fitness Center Equipment & Mirrors at Woodbridge Apartments, California,Fitness Center Equipment Cardio at Woodbridge Apartments, Sacramento CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efff4f226377203e83693e1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429657",
      "title": "2 Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd1-e24e-75bc-803f-ed80410d6d02.webp",
      "amenity_image_media": {
        "alt_text": "Community swimming pool with lounge chairs and umbrellas under a pergola.",
        "public_id": "019d4cd1-e24e-75bc-803f-ed80410d6d02",
        "storage_key": "property/6767906449166916/019d4cd1-e24e-75bc-803f-ed80410d6d02.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "swimming pool arbor and furniture at Woodbridge Apartments, CA 95833,swimming pool and spa at Woodbridge Apartments, California, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce754225ac3a80bcd70d49dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429656",
      "title": "2 Spas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd1-e2b7-7192-8795-a4bc63bc461e.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor pool and spa area with lounge chairs and seating under umbrellas.",
        "public_id": "019d4cd1-e2b7-7192-8795-a4bc63bc461e",
        "storage_key": "property/6767906449166916/019d4cd1-e2b7-7192-8795-a4bc63bc461e.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "spa at Woodbridge Apartments, Sacramento, 95833,spa and clubhouse back view at Woodbridge Apartments, Sacramento, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff499db22fcbfbc7df2767b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429660",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-55f7-760d-bfab-845d923a0d66.webp",
      "amenity_image_media": {
        "alt_text": "Playground equipment with apartment buildings in the background.",
        "public_id": "019d4cd2-55f7-760d-bfab-845d923a0d66",
        "storage_key": "property/6767906449166916/019d4cd2-55f7-760d-bfab-845d923a0d66.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "play structure at Woodbridge Apartments, California,playground at Woodbridge Apartments, Sacramento",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d35da095b5f2267f021aacc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429658",
      "title": "Flexible Lease Terms Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bda015d08a6c10596e36fd2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "87774876",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4982-b348-765b-acff-754fb6d5ddc5.webp",
      "amenity_image_media": {
        "alt_text": "Amazon Hub package lockers with a digital screen and keypad for package retrieval.",
        "public_id": "019d4982-b348-765b-acff-754fb6d5ddc5",
        "storage_key": "property/6767906449166916/019d4982-b348-765b-acff-754fb6d5ddc5.webp",
        "width": 3072,
        "height": 2304
      },
      "amenity_image_alt_text": "24 Hour Package Lockers at Woodbridge Apartments, Sacramento, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9c7f619515c10d312588987",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "86393171",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06ac63dbbac81f238ca2c3d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80683700",
      "title": "Indoor Basketball Half-Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04d3c248569b43b10316aaf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "86393170",
      "title": "Free Wi-Fi In Fitness Center & Pool Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58ea8f32919cc2031052d76f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429661",
      "title": "Sun Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd1-e2bf-75f1-abd9-fc32759e4a27.webp",
      "amenity_image_media": {
        "alt_text": "Community swimming pool area with lounge chairs and tables.",
        "public_id": "019d4cd1-e2bf-75f1-abd9-fc32759e4a27",
        "storage_key": "property/6767906449166916/019d4cd1-e2bf-75f1-abd9-fc32759e4a27.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "swimming pool fenced exterior at Woodbridge Apartments, Sacramento, California 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6aed465f83a58c7d5cc00435",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "87848908",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4982-ad6f-75c8-a188-f47cb7acdb5e.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment building with balcony and outdoor grill.",
        "public_id": "019d4982-ad6f-75c8-a188-f47cb7acdb5e",
        "storage_key": "property/6767906449166916/019d4982-ad6f-75c8-a188-f47cb7acdb5e.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "building exterior and bbq amenity at Woodbridge Apartments, Sacramento, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5cf1fe3cc60f38fad3de714a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429659",
      "title": "Resident Activities Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e073a2b9c7cb74aef614112",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "82390307",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d70dccceb9e544f67192c1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "82390313",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_566701249f5be8651d3c6e92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "86393173",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f011c1086afe6fc1747dad7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429666",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-a086-7327-9625-dc243771f960.webp",
      "amenity_image_media": {
        "alt_text": "In-unit stackable washer and dryer next to a sliding glass door.",
        "public_id": "019d4cd2-a086-7327-9625-dc243771f960",
        "storage_key": "property/6767906449166916/019d4cd2-a086-7327-9625-dc243771f960.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "laundry closet at Woodbridge Apartments, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f165cc481497ad2c19252aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429663",
      "title": "Central Heating And Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa8d4f115d696752760a4e0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429668",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-7aae-75f8-8296-15543a837e45.webp",
      "amenity_image_media": {
        "alt_text": "Private balcony with seating area and table, surrounded by trees.",
        "public_id": "019d4cd2-7aae-75f8-8296-15543a837e45",
        "storage_key": "property/6767906449166916/019d4cd2-7aae-75f8-8296-15543a837e45.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "model patio and furniture at Woodbridge Apartments, Sacramento",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e7e6c1ef7ce3592ed84a927",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429669",
      "title": "Fireplace - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81775e760d576bdb6a04667c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429667",
      "title": "Linen Closets - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8f565b996b5137e98297875",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429665",
      "title": "Dual Pane Energy Efficient Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4982-3580-7049-96dc-5d902f12b8a8.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment building with stairs and landscaping.",
        "public_id": "019d4982-3580-7049-96dc-5d902f12b8a8",
        "storage_key": "property/6767906449166916/019d4982-3580-7049-96dc-5d902f12b8a8.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "building exterior entries at Woodbridge Apartments, Sacramento, California 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68d1125f5ea64b74ea5ac95c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "yardi",
      "external_id": "80429664",
      "title": "Dressing Mirror/Vanity - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_fb1a082a4c7dfcc14f158b1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d42af-3602-741c-a2cf-f8e53c1e5b2e.webp",
      "image_media": {
        "alt_text": "Woodbridge Apartments monument sign with blooming flowers in the foreground.",
        "public_id": "019d42af-3602-741c-a2cf-f8e53c1e5b2e",
        "storage_key": "property/6767906449166916/019d42af-3602-741c-a2cf-f8e53c1e5b2e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to Woodbridge Apartments, featuring beautifully landscaped grounds and a prominent monument sign at the entrance.",
      "link": "false",
      "alt_text": "Woodbridge Apartments monument sign with blooming flowers in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Monument.jpg"
    },
    {
      "id": "ec_a8b408e165ea65c1768e760d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4982-3770-77c4-9315-6739ec99f606.webp",
      "image_media": {
        "alt_text": "Landscaped courtyard with a fountain and seating area in front of an apartment building.",
        "public_id": "019d4982-3770-77c4-9315-6739ec99f606",
        "storage_key": "property/6767906449166916/019d4982-3770-77c4-9315-6739ec99f606.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy the serene courtyard with a calming fountain and comfortable seating, surrounded by lush greenery and blooming flowers.",
      "link": "false",
      "alt_text": "Landscaped courtyard with a fountain and seating area in front of an apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_LeasingOfficeFountain.jpg"
    },
    {
      "id": "ec_1730076468323f8e3dd1c453",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4982-357f-7585-9f16-4de1155b5693.webp",
      "image_media": {
        "alt_text": "Fountain under a white pergola with stone pillars in a garden area.",
        "public_id": "019d4982-357f-7585-9f16-4de1155b5693",
        "storage_key": "property/6767906449166916/019d4982-357f-7585-9f16-4de1155b5693.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy the serene ambiance of our community's charming garden courtyard, featuring a beautiful fountain and lush landscaping.",
      "link": "false",
      "alt_text": "Fountain under a white pergola with stone pillars in a garden area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_LeasingOfficeFountainPoolView.jpg"
    },
    {
      "id": "ec_8adb6d3dace8ac3e5399b171",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4982-3580-7049-96dc-5d902f12b8a8.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with stairs and landscaping.",
        "public_id": "019d4982-3580-7049-96dc-5d902f12b8a8",
        "storage_key": "property/6767906449166916/019d4982-3580-7049-96dc-5d902f12b8a8.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing the architectural details and surrounding greenery.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with stairs and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_BuildingExteriorEntries.jpg"
    },
    {
      "id": "ec_9dba3a9a8bed5630436b8d61",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4982-3525-7698-87a9-2bd48a3d0155.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with walkways and manicured lawns.",
        "public_id": "019d4982-3525-7698-87a9-2bd48a3d0155",
        "storage_key": "property/6767906449166916/019d4982-3525-7698-87a9-2bd48a3d0155.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Charming apartment buildings with exterior walkways and well-kept green spaces, offering a pleasant community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with walkways and manicured lawns.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_BuildingExteriorPaths.jpg"
    },
    {
      "id": "ec_c04af4aa7e69db23cea87981",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4982-3584-713d-99b4-29a445f0a38e.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and staircases.",
        "public_id": "019d4982-3584-713d-99b4-29a445f0a38e",
        "storage_key": "property/6767906449166916/019d4982-3584-713d-99b4-29a445f0a38e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Beautiful exterior view of the apartment buildings, showcasing the balconies and staircases.",
      "link": "false",
      "alt_text": "Exterior view of an apartment building with balconies and staircases.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_BuildingExteriorCarports.jpg"
    },
    {
      "id": "ec_5dc52d2b97c1f5525724ec39",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4982-a5ff-74a3-a3ca-83fc0d13b0ea.webp",
      "image_media": {
        "alt_text": "Exterior buildings and green lawn with a walkway",
        "public_id": "019d4982-a5ff-74a3-a3ca-83fc0d13b0ea",
        "storage_key": "property/6767906449166916/019d4982-a5ff-74a3-a3ca-83fc0d13b0ea.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with mature trees and a paved walkway leading to the apartment buildings. Enjoy the spacious green areas and the charm of this community.",
      "link": "false",
      "alt_text": "Exterior buildings and green lawn with a walkway",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_BuildingExteriorGreenSpace.jpg"
    },
    {
      "id": "ec_b730ee7db1c5e2d45ae410ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4982-ad6f-75c8-a188-f47cb7acdb5e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with balcony and outdoor grill.",
        "public_id": "019d4982-ad6f-75c8-a188-f47cb7acdb5e",
        "storage_key": "property/6767906449166916/019d4982-ad6f-75c8-a188-f47cb7acdb5e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy the outdoors with this apartment building's exterior featuring a private balcony and a convenient outdoor grill area.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with balcony and outdoor grill.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_BuildingExteriorBBQAmenity.jpg"
    },
    {
      "id": "ec_d00fbfaee75a3080101d5075",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d42af-800c-777b-bd14-41d979061295.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight training equipment, and a punching bag.",
        "public_id": "019d42af-800c-777b-bd14-41d979061295",
        "storage_key": "property/6767906449166916/019d42af-800c-777b-bd14-41d979061295.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Our fully equipped fitness center offers state-of-the-art cardio machines, weight training equipment, and a boxing area for a complete workout experience.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, weight training equipment, and a punching bag.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_FitnessCenterEquipment01.jpg"
    },
    {
      "id": "ec_7570579581e75f8877129230",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d42af-7ef2-70a2-bd24-a38dcb10c6cc.webp",
      "image_media": {
        "alt_text": "Interior of a well-equipped apartment complex gym with various weight machines, exercise balls, and resistance bands.",
        "public_id": "019d42af-7ef2-70a2-bd24-a38dcb10c6cc",
        "storage_key": "property/6767906449166916/019d42af-7ef2-70a2-bd24-a38dcb10c6cc.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring a wide range of cardio and strength training equipment for your workout needs.",
      "link": "false",
      "alt_text": "Interior of a well-equipped apartment complex gym with various weight machines, exercise balls, and resistance bands.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_FitnessCenterEquipment02.jpg"
    },
    {
      "id": "ec_24e3e711f361f499876b8a55",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d42af-890b-7458-a022-1b1fc7d130cd.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and punching bags.",
        "public_id": "019d42af-890b-7458-a022-1b1fc7d130cd",
        "storage_key": "property/6767906449166916/019d42af-890b-7458-a022-1b1fc7d130cd.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a full range of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, weight machines, and punching bags.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_FitnessCenterEquipmentMirrors.jpg"
    },
    {
      "id": "ec_bd5dd66bf151516cd011a88e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d42af-b3ff-71cc-b8cf-794c9bf29f4a.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a fitness center",
        "public_id": "019d42af-b3ff-71cc-b8cf-794c9bf29f4a",
        "storage_key": "property/6767906449166916/019d42af-b3ff-71cc-b8cf-794c9bf29f4a.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Equipped fitness center featuring treadmills and elliptical machines for resident use.",
      "link": "false",
      "alt_text": "Treadmills and elliptical machines in a fitness center",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_FitnessCenterEquipmentCardio.jpg"
    },
    {
      "id": "ec_c0b8098cfe5d4f46074979fb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4982-b348-765b-acff-754fb6d5ddc5.webp",
      "image_media": {
        "alt_text": "Amazon Hub package lockers with a digital screen and keypad for package retrieval.",
        "public_id": "019d4982-b348-765b-acff-754fb6d5ddc5",
        "storage_key": "property/6767906449166916/019d4982-b348-765b-acff-754fb6d5ddc5.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Secure and convenient package lockers for residents, featuring Amazon Hub and a user-friendly digital interface.",
      "link": "false",
      "alt_text": "Amazon Hub package lockers with a digital screen and keypad for package retrieval.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_24HourPackageLockers(1).jpg"
    },
    {
      "id": "ec_87505d8ed779d4a17a6c579c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4982-c3b7-734c-917c-7b13f6a34567.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d4982-c3b7-734c-917c-7b13f6a34567",
        "storage_key": "property/6767906449166916/019d4982-c3b7-734c-917c-7b13f6a34567.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable lounge seating. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/_DSC5448.jpg"
    },
    {
      "id": "ec_68cf6737d9c135cb1a9da451",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd1-e2bf-75f1-abd9-fc32759e4a27.webp",
      "image_media": {
        "alt_text": "Community swimming pool area with lounge chairs and tables.",
        "public_id": "019d4cd1-e2bf-75f1-abd9-fc32759e4a27",
        "storage_key": "property/6767906449166916/019d4cd1-e2bf-75f1-abd9-fc32759e4a27.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool, perfect for relaxation and recreation. Plenty of seating available for lounging.",
      "link": "false",
      "alt_text": "Community swimming pool area with lounge chairs and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_SwimmingPoolExterior.jpg"
    },
    {
      "id": "ec_296296d03b41dc5971b5b1cf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd1-e2b1-766e-a00f-4198dd57fde6.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with seating and umbrellas.",
        "public_id": "019d4cd1-e2b1-766e-a00f-4198dd57fde6",
        "storage_key": "property/6767906449166916/019d4cd1-e2b1-766e-a00f-4198dd57fde6.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool or relax in the soothing hot tub. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and hot tub with seating and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_SwimmingPoolSpa.jpg"
    },
    {
      "id": "ec_bceb027c54b0184c54cb946f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd1-e2b7-7192-8795-a4bc63bc461e.webp",
      "image_media": {
        "alt_text": "Outdoor pool and spa area with lounge chairs and seating under umbrellas.",
        "public_id": "019d4cd1-e2b7-7192-8795-a4bc63bc461e",
        "storage_key": "property/6767906449166916/019d4cd1-e2b7-7192-8795-a4bc63bc461e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling pool and soothing spa, perfect for enjoying the California sunshine. Ample seating and shade available.",
      "link": "false",
      "alt_text": "Outdoor pool and spa area with lounge chairs and seating under umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_SpaView.jpg"
    },
    {
      "id": "ec_76f0f5dea3d5a64d4a3c908b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd1-e31c-70da-9948-133c1c33f068.webp",
      "image_media": {
        "alt_text": "Outdoor spa area with seating and umbrellas next to a swimming pool and building.",
        "public_id": "019d4cd1-e31c-70da-9948-133c1c33f068",
        "storage_key": "property/6767906449166916/019d4cd1-e31c-70da-9948-133c1c33f068.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind in our luxurious outdoor spa, surrounded by lush greenery and convenient seating. Perfect for enjoying a sunny day or a cool evening.",
      "link": "false",
      "alt_text": "Outdoor spa area with seating and umbrellas next to a swimming pool and building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_SpaClubhouseBack.jpg"
    },
    {
      "id": "ec_02342a2bfef806c050dd46b2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd1-e24e-75bc-803f-ed80410d6d02.webp",
      "image_media": {
        "alt_text": "Community swimming pool with lounge chairs and umbrellas under a pergola.",
        "public_id": "019d4cd1-e24e-75bc-803f-ed80410d6d02",
        "storage_key": "property/6767906449166916/019d4cd1-e24e-75bc-803f-ed80410d6d02.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax by the sparkling community swimming pool, featuring comfortable lounge chairs and shaded areas perfect for a sunny day.",
      "link": "false",
      "alt_text": "Community swimming pool with lounge chairs and umbrellas under a pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_SwimmingPoolArborFurniture.jpg"
    },
    {
      "id": "ec_851fc75feda8047744616a3d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-44bf-712d-a04d-a60987ca1ac5.webp",
      "image_media": {
        "alt_text": "Playground with slides, monkey bars, and benches.",
        "public_id": "019d4cd2-44bf-712d-a04d-a60987ca1ac5",
        "storage_key": "property/6767906449166916/019d4cd2-44bf-712d-a04d-a60987ca1ac5.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Children's playground area with colorful equipment, benches, and surrounded by trees and apartment buildings.",
      "link": "false",
      "alt_text": "Playground with slides, monkey bars, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Playground.jpg"
    },
    {
      "id": "ec_8b91374bda294298c875b180",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-55f7-760d-bfab-845d923a0d66.webp",
      "image_media": {
        "alt_text": "Playground equipment with apartment buildings in the background.",
        "public_id": "019d4cd2-55f7-760d-bfab-845d923a0d66",
        "storage_key": "property/6767906449166916/019d4cd2-55f7-760d-bfab-845d923a0d66.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for residents of all ages.",
      "link": "false",
      "alt_text": "Playground equipment with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_PlayStructure.jpg"
    },
    {
      "id": "ec_ae7f88228cc12dc0258ffb85",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-26c1-71fc-9f0c-67e758d7a83f.webp",
      "image_media": {
        "alt_text": "White kitchen with black granite countertops, a stainless steel sink, and a black refrigerator.",
        "public_id": "019d4cd2-26c1-71fc-9f0c-67e758d7a83f",
        "storage_key": "property/6767906449166916/019d4cd2-26c1-71fc-9f0c-67e758d7a83f.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Modern white kitchen featuring ample cabinet space, black granite countertops, and a full suite of appliances including a dishwasher and refrigerator.",
      "link": "false",
      "alt_text": "White kitchen with black granite countertops, a stainless steel sink, and a black refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_ModelKitchen.jpg"
    },
    {
      "id": "ec_566c907c270330f55e42e04a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-346d-727f-afa1-79ce30cb1b2f.webp",
      "image_media": {
        "alt_text": "Kitchen with a dining table and chairs, white cabinets, black appliances, and a large wall clock.",
        "public_id": "019d4cd2-346d-727f-afa1-79ce30cb1b2f",
        "storage_key": "property/6767906449166916/019d4cd2-346d-727f-afa1-79ce30cb1b2f.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this spacious kitchen featuring ample cabinet space, modern black appliances, and a charming dining area perfect for intimate meals.",
      "link": "false",
      "alt_text": "Kitchen with a dining table and chairs, white cabinets, black appliances, and a large wall clock.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_ModelKitchenDiningRoom.jpg"
    },
    {
      "id": "ec_e5426a5135f480e3eb2098fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-1f92-72cd-9e13-8ef3c51e9d20.webp",
      "image_media": {
        "alt_text": "Living room with a TV, accent chairs, coffee table, and yellow curtains.",
        "public_id": "019d4cd2-1f92-72cd-9e13-8ef3c51e9d20",
        "storage_key": "property/6767906449166916/019d4cd2-1f92-72cd-9e13-8ef3c51e9d20.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a wall-mounted TV, comfortable seating with accent chairs, a textured coffee table, and vibrant yellow curtains, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Living room with a TV, accent chairs, coffee table, and yellow curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_ModelLivingRoomPatio.jpg"
    },
    {
      "id": "ec_0e13ac27711d50d978b1176e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-3b0a-701e-814c-383bfad2faf8.webp",
      "image_media": {
        "alt_text": "Living room with sofa, chairs, coffee table, and TV.",
        "public_id": "019d4cd2-3b0a-701e-814c-383bfad2faf8",
        "storage_key": "property/6767906449166916/019d4cd2-3b0a-701e-814c-383bfad2faf8.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a plush sofa, accent chairs, and a modern coffee table, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Living room with sofa, chairs, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_ModelLivingRoom.jpg"
    },
    {
      "id": "ec_27b8ddf54de557f0d7277032",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-672d-7673-bdc1-8fcd53d9ff94.webp",
      "image_media": {
        "alt_text": "A clean and well-lit bedroom featuring a large bed with white linens, a gray upholstered headboard, and two abstract paintings on the wall.",
        "public_id": "019d4cd2-672d-7673-bdc1-8fcd53d9ff94",
        "storage_key": "property/6767906449166916/019d4cd2-672d-7673-bdc1-8fcd53d9ff94.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this beautifully appointed bedroom, perfect for relaxation after a long day. Features a plush queen-sized bed and elegant decor.",
      "link": "false",
      "alt_text": "A clean and well-lit bedroom featuring a large bed with white linens, a gray upholstered headboard, and two abstract paintings on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_ModelPrimaryBedroom.jpg"
    },
    {
      "id": "ec_59b0d6f7285d5940678b37d3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-8147-727c-96f3-8feacb40755f.webp",
      "image_media": {
        "alt_text": "A bedroom or office space with a desk, chair, and closet.",
        "public_id": "019d4cd2-8147-727c-96f3-8feacb40755f",
        "storage_key": "property/6767906449166916/019d4cd2-8147-727c-96f3-8feacb40755f.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Create a productive atmosphere in this bedroom or office space, complete with a desk, comfortable chair, and ample closet space.",
      "link": "false",
      "alt_text": "A bedroom or office space with a desk, chair, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_ModelSecondBedroom(1).jpg"
    },
    {
      "id": "ec_5ec3ec56ae975d5dc09d2706",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-84d8-71ce-9644-98a7f9aa4cee.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and shower with a decorative curtain.",
        "public_id": "019d4cd2-84d8-71ce-9644-98a7f9aa4cee",
        "storage_key": "property/6767906449166916/019d4cd2-84d8-71ce-9644-98a7f9aa4cee.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a sink, a toilet, and a shower/tub combo with a decorative shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with vanity, sink, toilet, and shower with a decorative curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_ModelBathroom.jpg"
    },
    {
      "id": "ec_3c1b797e3d7acbfd81de0e13",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-7aae-75f8-8296-15543a837e45.webp",
      "image_media": {
        "alt_text": "Private balcony with seating area and table, surrounded by trees.",
        "public_id": "019d4cd2-7aae-75f8-8296-15543a837e45",
        "storage_key": "property/6767906449166916/019d4cd2-7aae-75f8-8296-15543a837e45.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relax on your private balcony. This outdoor space offers a cozy seating area and a small table, perfect for personal use.",
      "link": "false",
      "alt_text": "Private balcony with seating area and table, surrounded by trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_ModelPatio.jpg"
    },
    {
      "id": "ec_897cf69c9c78af70b7ec5879",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-8d74-7294-902d-925ef71952cb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black granite countertops, and stainless steel appliances.",
        "public_id": "019d4cd2-8d74-7294-902d-925ef71952cb",
        "storage_key": "property/6767906449166916/019d4cd2-8d74-7294-902d-925ef71952cb.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "This kitchen features sleek white cabinetry, durable black granite countertops, and a full suite of modern appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, black granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant1x1Kitchen.jpg"
    },
    {
      "id": "ec_8ad9730e7abfacced04725c7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-add6-7224-94be-64f686ec786e.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets and black appliances.",
        "public_id": "019d4cd2-add6-7224-94be-64f686ec786e",
        "storage_key": "property/6767906449166916/019d4cd2-add6-7224-94be-64f686ec786e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "View of a compact kitchen featuring white cabinetry, black appliances including a refrigerator, stove, and dishwasher. The flooring is wood-look laminate.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant1x1DiningRoom.jpg"
    },
    {
      "id": "ec_34267c9cedc994bcd2462f01",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-a086-7327-9625-dc243771f960.webp",
      "image_media": {
        "alt_text": "In-unit stackable washer and dryer next to a sliding glass door.",
        "public_id": "019d4cd2-a086-7327-9625-dc243771f960",
        "storage_key": "property/6767906449166916/019d4cd2-a086-7327-9625-dc243771f960.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer tucked away in a closet, with a sliding glass door leading to a patio or balcony.",
      "link": "false",
      "alt_text": "In-unit stackable washer and dryer next to a sliding glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant1x1Laundry.jpg"
    },
    {
      "id": "ec_c1ee5c1a55c747666680905c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-c5ac-753b-9650-b8cf4680cad6.webp",
      "image_media": {
        "alt_text": "Empty living room with beige carpet, a front door, and a large window.",
        "public_id": "019d4cd2-c5ac-753b-9650-b8cf4680cad6",
        "storage_key": "property/6767906449166916/019d4cd2-c5ac-753b-9650-b8cf4680cad6.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Step into this inviting living space, featuring plush beige carpeting and ample natural light from a large window. The entryway is bright and welcoming.",
      "link": "false",
      "alt_text": "Empty living room with beige carpet, a front door, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant1x1LivingRoomEntry.jpg"
    },
    {
      "id": "ec_ebc25d72f934f2a941ad6119",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-a8bb-737c-b55b-da5e8fcc6a46.webp",
      "image_media": {
        "alt_text": "Bedroom with carpet, two doors, and a window.",
        "public_id": "019d4cd2-a8bb-737c-b55b-da5e8fcc6a46",
        "storage_key": "property/6767906449166916/019d4cd2-a8bb-737c-b55b-da5e8fcc6a46.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a large window with blinds, a closet, and access to additional rooms through interior doors.",
      "link": "false",
      "alt_text": "Bedroom with carpet, two doors, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant1x1Bedroom.jpg"
    },
    {
      "id": "ec_8ec4b1efecc4a2a1f52ca935",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-c0bf-767c-bdc8-2c7bba36a0a3.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "019d4cd2-c0bf-767c-bdc8-2c7bba36a0a3",
        "storage_key": "property/6767906449166916/019d4cd2-c0bf-767c-bdc8-2c7bba36a0a3.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Step into a clean and functional bathroom featuring a modern vanity with a granite-look countertop, a comfortable toilet, and a pristine shower and tub combination.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant1x1Bathroom.jpg"
    },
    {
      "id": "ec_3d2355c5c8d228a7066da764",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-d23c-7571-a55c-6de9d2380da4.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black countertops, a black stove, dishwasher, and refrigerator.",
        "public_id": "019d4cd2-d23c-7571-a55c-6de9d2380da4",
        "storage_key": "property/6767906449166916/019d4cd2-d23c-7571-a55c-6de9d2380da4.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring sleek white cabinetry, durable black countertops, and black appliances including a stove, dishwasher, and refrigerator.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black countertops, a black stove, dishwasher, and refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant2x2Kitchen.jpg"
    },
    {
      "id": "ec_f17baba0724c67d7235cebdb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-dc03-71cd-a214-6e7304a75f56.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black countertops, and black appliances.",
        "public_id": "019d4cd2-dc03-71cd-a214-6e7304a75f56",
        "storage_key": "property/6767906449166916/019d4cd2-dc03-71cd-a214-6e7304a75f56.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white cabinetry, black granite countertops, and a full suite of black appliances including a refrigerator, dishwasher, and stove. The dark wood-look flooring complements the space.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black countertops, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant2x2KitchenSideView.jpg"
    },
    {
      "id": "ec_d7c85abfbb4333d747e1d693",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-de47-742b-8a12-2122acfaeaa9.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment kitchen area with a black refrigerator and stacked washer/dryer.",
        "public_id": "019d4cd2-de47-742b-8a12-2122acfaeaa9",
        "storage_key": "property/6767906449166916/019d4cd2-de47-742b-8a12-2122acfaeaa9.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer located next to the kitchen area, complete with a refrigerator and ample cabinet space.",
      "link": "false",
      "alt_text": "Interior view of an apartment kitchen area with a black refrigerator and stacked washer/dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant2x2DiningRoomLaundry.jpg"
    },
    {
      "id": "ec_2203a62da256349e6894595f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-fbf7-729f-a314-8ca21581eaa5.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and view into kitchen",
        "public_id": "019d4cd2-fbf7-729f-a314-8ca21581eaa5",
        "storage_key": "property/6767906449166916/019d4cd2-fbf7-729f-a314-8ca21581eaa5.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living area with a fireplace and a view into the modern kitchen, featuring white cabinetry and a black refrigerator.",
      "link": "false",
      "alt_text": "Living room with fireplace and view into kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant2x2LivingRoomKitchenView.jpg"
    },
    {
      "id": "ec_804e308937e5419caa749e86",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd2-eb2b-71ad-8a47-e08e9dec19be.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and large window",
        "public_id": "019d4cd2-eb2b-71ad-8a47-e08e9dec19be",
        "storage_key": "property/6767906449166916/019d4cd2-eb2b-71ad-8a47-e08e9dec19be.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace and a large window that lets in plenty of natural light.",
      "link": "false",
      "alt_text": "Living room with fireplace and large window",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant2x2LivingRoomEntry.jpg"
    },
    {
      "id": "ec_3ced48b4d6488c50a16e34ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd3-1ebb-731e-bd87-be15963c3aff.webp",
      "image_media": {
        "alt_text": "Spacious living room with carpet and a window with blinds.",
        "public_id": "019d4cd3-1ebb-731e-bd87-be15963c3aff",
        "storage_key": "property/6767906449166916/019d4cd3-1ebb-731e-bd87-be15963c3aff.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "View of a spacious living area with plush carpeting, a large window, and access to other rooms.",
      "link": "false",
      "alt_text": "Spacious living room with carpet and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant2x2LivingRoomHallway.jpg"
    },
    {
      "id": "ec_33d8c07404e921893d2dc7f1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd3-1707-766d-a4b5-2db350651922.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and window.",
        "public_id": "019d4cd3-1707-766d-a4b5-2db350651922",
        "storage_key": "property/6767906449166916/019d4cd3-1707-766d-a4b5-2db350651922.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a spacious closet and a large window with blinds, offering natural light. Enjoy a comfortable living space with plush carpeting.",
      "link": "false",
      "alt_text": "Bedroom with closet and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant2x2PrimaryBedroom.jpg"
    },
    {
      "id": "ec_db091df75e9fcb6985a27c94",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd3-0551-7496-91d8-9cc69ec633f1.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and window.",
        "public_id": "019d4cd3-0551-7496-91d8-9cc69ec633f1",
        "storage_key": "property/6767906449166916/019d4cd3-0551-7496-91d8-9cc69ec633f1.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Cozy bedroom with a sliding door closet and a large window, offering a comfortable living space.",
      "link": "false",
      "alt_text": "Bedroom with closet and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant2x2SecondBedroom.jpg"
    },
    {
      "id": "ec_2e960e1335183b0d478ecb1e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd3-1e5b-7569-9826-af48d1be0752.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and entrance to shower/tub.",
        "public_id": "019d4cd3-1e5b-7569-9826-af48d1be0752",
        "storage_key": "property/6767906449166916/019d4cd3-1e5b-7569-9826-af48d1be0752.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a sink and mirror, and a separate shower/tub area. Perfect for everyday convenience.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, mirror, and entrance to shower/tub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant2x2PrimaryBathroom.jpg"
    },
    {
      "id": "ec_389315338221dbcec754a8d2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d4cd3-2b44-745a-9601-56a6c59af7ec.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and mirror.",
        "public_id": "019d4cd3-2b44-745a-9601-56a6c59af7ec",
        "storage_key": "property/6767906449166916/019d4cd3-2b44-745a-9601-56a6c59af7ec.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy a clean and functional bathroom in your new apartment, complete with a vanity, sink, toilet, and mirror.",
      "link": "false",
      "alt_text": "Bathroom with vanity, sink, toilet, and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Woodbridge_Sacramento_CA_Vacant2x2SecondBathroom.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_91283116-46c6-4b35-b484-04681fa7b443",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "2001 Alta Arden Expy, Sacramento, CA 95825, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious Double Doubles, animal fries, and milkshakes. They highlight the fresh food, fast service, and friendly staff. They also like the good value and efficient drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-aab9-70f9-85fe-a56e5a2c78d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-aab9-70f9-85fe-a56e5a2c78d4",
        "storage_key": "property/6767906449166916/019d08b1-aab9-70f9-85fe-a56e5a2c78d4.webp",
        "width": 1102,
        "height": 1280
      },
      "poi_business_url": "https://locations.in-n-out.com/276",
      "poi_directions_map_url": "https://maps.google.com/?cid=4866440018724358803&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.5980167",
      "poi_longitude": "-121.4194193",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-59b1-732e-a06b-eb4f572c0e45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-59b1-732e-a06b-eb4f572c0e45",
        "storage_key": "property/6767906449166916/019d08b1-59b1-732e-a06b-eb4f572c0e45.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ6ToLSPamoARk4rP3GkRiUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_b8a758ca-bd13-4213-b635-246e9c99baf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2101 Alta Arden Expy, Sacramento, CA 95825, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant offers delicious chicken sandwiches, salads, and shakes. They also highlight the friendly staff, fast service, and clean atmosphere.\n\nOther reviews mention orders can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-aa6f-7250-ae45-e43941884b12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-aa6f-7250-ae45-e43941884b12",
        "storage_key": "property/6767906449166916/019d08b1-aa6f-7250-ae45-e43941884b12.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ca/arden-fair?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=15156801471129607094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "38.5987882",
      "poi_longitude": "-121.4174906",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 916-922-2814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-59b1-732e-a06b-eb4f572c0e45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-59b1-732e-a06b-eb4f572c0e45",
        "storage_key": "property/6767906449166916/019d08b1-59b1-732e-a06b-eb4f572c0e45.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Sz6ViPamoARtlvMQaLGV9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_4db86146-6248-4016-ace7-1f284b28288f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Tower Café",
      "poi_type": "Restaurants",
      "poi_address": "1518 Broadway, Sacramento, CA 95818, USA",
      "poi_short_description": "Quirky cafe serving an eclectic array of grub, from classic breakfasts to Asian and Spanish mains.",
      "poi_long_description": "People say this restaurant serves delicious French toast, Thai steak and eggs, and salads. They highlight the large portions, diverse menu, and beautiful outdoor seating area with fountains and lush greenery. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-aaf5-73ab-9760-28b654d8ee2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-aaf5-73ab-9760-28b654d8ee2c",
        "storage_key": "property/6767906449166916/019d08b1-aaf5-73ab-9760-28b654d8ee2c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.towercafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17467647007537499128&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tower-caf",
      "poi_latitude": "38.5616745",
      "poi_longitude": "-121.4935217",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-441-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-59b1-732e-a06b-eb4f572c0e45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-59b1-732e-a06b-eb4f572c0e45",
        "storage_key": "property/6767906449166916/019d08b1-59b1-732e-a06b-eb4f572c0e45.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM4Wmdx7RmoAR-Asw4meMafI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_40696afb-94f3-4429-9f70-793a74b041d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Drake's: The Barn",
      "poi_type": "Restaurants",
      "poi_address": "985 Riverfront St, West Sacramento, CA 95691, USA",
      "poi_short_description": "Outdoor gathering place with a beer garden, pizzeria & 3 stages hosting DJs & live music shows.",
      "poi_long_description": "People say this beer garden offers a great selection of beers, delicious pizzas, and burgers. They highlight the fun, energetic, and lively atmosphere, and the spacious outdoor seating with fire pits. They also like that it's dog-friendly and family-friendly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-aad7-7141-8eec-a82e276e0e13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-aad7-7141-8eec-a82e276e0e13",
        "storage_key": "property/6767906449166916/019d08b1-aad7-7141-8eec-a82e276e0e13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://drinkdrakes.com/places/the-barn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4212264906490894141&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "drakes-the-barn",
      "poi_latitude": "38.574851",
      "poi_longitude": "-121.514729",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-ed77-75fb-bf19-9a470cc475de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-ed77-75fb-bf19-9a470cc475de",
        "storage_key": "property/6767906449166916/019d08b1-ed77-75fb-bf19-9a470cc475de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIzOrD0rRmoARPdc7a534dDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_b5f300af-ec19-43e2-b899-7a5a854f96ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Urban Roots Brewery & Smokehouse",
      "poi_type": "Restaurants",
      "poi_address": "1322 V St, Sacramento, CA 95818, USA",
      "poi_short_description": "Stylish indoor-outdoor joint serving a wide variety of housemade beers alongside hearty BBQ fare.",
      "poi_long_description": "People say this brewpub serves delicious brisket, burnt ends, and BBQ turkey, and offers a variety of tasty sides. They highlight the generous portions, the self-serve BBQ sauce bar with three different sauces, and the friendly staff. They also like the fun, laid-back atmosphere, with both indoor and outdoor seating, and the extensive selection of craft beers and ciders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-b26e-7196-b404-249aeb035fbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-b26e-7196-b404-249aeb035fbf",
        "storage_key": "property/6767906449166916/019d08b1-b26e-7196-b404-249aeb035fbf.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.urbanrootsbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=322330605051558123&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-roots-brewery--smokehouse",
      "poi_latitude": "38.5655783",
      "poi_longitude": "-121.4941211",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-706-3741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-ed77-75fb-bf19-9a470cc475de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-ed77-75fb-bf19-9a470cc475de",
        "storage_key": "property/6767906449166916/019d08b1-ed77-75fb-bf19-9a470cc475de.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI6W_gh_RmoAR67hVPvoleQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_c41af26b-ecef-43b3-8a52-9f0f6646686a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Arden Fair",
      "poi_type": "Shopping & Retail",
      "poi_address": "1689 Arden Way, Sacramento, CA 95815, USA",
      "poi_short_description": "Bright, spacious mall featuring 150+ shops, a food court with fast food & full-service restaurants.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including clothing, shoes, and tech, as well as a large food court with diverse options. They also highlight the clean and well-maintained environment, and the presence of security.\n\nOther reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-b25b-7417-b153-83fb32507b19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-b25b-7417-b153-83fb32507b19",
        "storage_key": "property/6767906449166916/019d08b1-b25b-7417-b153-83fb32507b19.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ardenfair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15499193860254925598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arden-fair",
      "poi_latitude": "38.6011646",
      "poi_longitude": "-121.4276086",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-920-1167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-592e-72bb-946c-193a12cee7da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-592e-72bb-946c-193a12cee7da",
        "storage_key": "property/6767906449166916/019d08b1-592e-72bb-946c-193a12cee7da.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLwm9mh7amoARHgNpmbIyGNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_64c337c2-fcd3-4396-8d8f-d75746c68a89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "700 Ikea Ct, West Sacramento, CA 95605, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide variety of products, including beds, home decor, and Swedish meatballs. They also highlight the reasonable prices, clean and organized environment, and friendly staff.\n\nSome reviews mention the food court can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-b268-7399-975c-871c6320b37d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-b268-7399-975c-871c6320b37d",
        "storage_key": "property/6767906449166916/019d08b1-b268-7399-975c-871c6320b37d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/west-sacramento/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=west-sacramento",
      "poi_directions_map_url": "https://maps.google.com/?cid=1134161977023253649&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "38.58660769999999",
      "poi_longitude": "-121.5535253",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-592e-72bb-946c-193a12cee7da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-592e-72bb-946c-193a12cee7da",
        "storage_key": "property/6767906449166916/019d08b1-592e-72bb-946c-193a12cee7da.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzyahGxSo6lQRkcw5Hk9avQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_92d05b07-df36-4928-89db-5adf7fbebc46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 Folsom Blvd, Sacramento, CA 95819, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique, healthy, and organic foods, including fresh produce, snacks, and frozen meals. They highlight the reasonable prices, especially for flowers and cheese, and the friendly, helpful staff. They also like the well-stocked aisles and the clean, organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-b455-702e-becd-e4e13c782c61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-b455-702e-becd-e4e13c782c61",
        "storage_key": "property/6767906449166916/019d08b1-b455-702e-becd-e4e13c782c61.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/sacramento/175/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5778462611759847179&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.5603947",
      "poi_longitude": "-121.4448167",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 916-456-1853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-59b5-71de-8235-3f55e7cf01f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-59b5-71de-8235-3f55e7cf01f2",
        "storage_key": "property/6767906449166916/019d08b1-59b5-71de-8235-3f55e7cf01f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRh5PYDamoARC1fSOSE5MVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ee4a1232-15d3-473a-b772-cb2d0d711e31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Sacramento Natural Foods Co-op",
      "poi_type": "Shopping & Retail",
      "poi_address": "2820 R St, Sacramento, CA 95816, USA",
      "poi_short_description": "Sustainably minded market for seasonal, organic produce as well as meats, fish & specialty foods.",
      "poi_long_description": "People say this grocery store offers a wide variety of natural, organic, and local products, including fresh produce, bulk items, and prepared foods. They highlight the clean, well-organized layout, and the convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-b89b-75ff-a455-19e1b6007ecd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-b89b-75ff-a455-19e1b6007ecd",
        "storage_key": "property/6767906449166916/019d08b1-b89b-75ff-a455-19e1b6007ecd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sac.coop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15451927587609601651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-natural-foods-co-op",
      "poi_latitude": "38.5645864",
      "poi_longitude": "-121.4725986",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-455-2667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-59b5-71de-8235-3f55e7cf01f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-59b5-71de-8235-3f55e7cf01f2",
        "storage_key": "property/6767906449166916/019d08b1-59b5-71de-8235-3f55e7cf01f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXyB2vvLQmoARc2aH6kVGcNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7e1d39d6-2da4-4d9e-9b8f-c695dc09e3a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1814 19th St, Sacramento, CA 95811, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "People say this grocery store offers a wide variety of items, including fresh produce, prepared meals, and a deli section with sandwiches. They also highlight the friendly and helpful staff, the clean and well-maintained facility, and the convenient location with ample parking.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-b973-700c-b717-2fc51ad908c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-b973-700c-b717-2fc51ad908c8",
        "storage_key": "property/6767906449166916/019d08b1-b973-700c-b717-2fc51ad908c8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.safeway.com/safeway/ca/sacramento/1814-19th-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=9086144474484919629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "38.5679278",
      "poi_longitude": "-121.4860899",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-492-9967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-59b5-71de-8235-3f55e7cf01f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-59b5-71de-8235-3f55e7cf01f2",
        "storage_key": "property/6767906449166916/019d08b1-59b5-71de-8235-3f55e7cf01f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_q7ruDQmoARTU2NU0J4GH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a79e8792-b007-4f71-9188-5ee5d4263602",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Sacramento City College",
      "poi_type": "Education",
      "poi_address": "3835 Freeport Blvd, Sacramento, CA 95822, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-bbe8-742c-9ac1-34809ed6415c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-bbe8-742c-9ac1-34809ed6415c",
        "storage_key": "property/6767906449166916/019d08b1-bbe8-742c-9ac1-34809ed6415c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.scc.losrios.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=530924599920790724&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-city-college",
      "poi_latitude": "38.5410812",
      "poi_longitude": "-121.4879724",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-558-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-5f7f-7079-b5fe-6d28e1acc52a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-5f7f-7079-b5fe-6d28e1acc52a",
        "storage_key": "property/6767906449166916/019d08b1-5f7f-7079-b5fe-6d28e1acc52a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIaIDi03QmoARxIzLVBw5Xgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_42467f20-f6c4-4473-a085-01fa7bfcc786",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Sacramento Central Public Library",
      "poi_type": "Education",
      "poi_address": "828 I St, Sacramento, CA 95814, USA",
      "poi_short_description": "Downtown institution offering books, computers, workshops and events for all ages. Books, videos and DVDs can also be borrowed via a library card. Spacious venue.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-bc7a-7689-8e13-6b9bf85153e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-bc7a-7689-8e13-6b9bf85153e3",
        "storage_key": "property/6767906449166916/019d08b1-bc7a-7689-8e13-6b9bf85153e3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.saclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1674841591450889779&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-central-public-library",
      "poi_latitude": "38.5816683",
      "poi_longitude": "-121.4950844",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-264-2920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-5f7f-7079-b5fe-6d28e1acc52a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-5f7f-7079-b5fe-6d28e1acc52a",
        "storage_key": "property/6767906449166916/019d08b1-5f7f-7079-b5fe-6d28e1acc52a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTfsMYyvRmoARM-56wY07Phc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_45524b8e-b2ed-4d15-a0ac-1b643e713a83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Golden 1 Center",
      "poi_type": "Entertainment",
      "poi_address": "500 David J Stern Walk, Sacramento, CA 95814, USA",
      "poi_short_description": "Modern venue built for basketball games, concerts and events, featuring a vegan food station.",
      "poi_long_description": "People say this arena offers a variety of drinks and snacks, and hosts concerts and basketball games. They highlight the comfortable seating, modern design, and excellent sound and video quality. They also like the friendly and helpful staff, and the convenient location with nearby parking and restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-10b8-720a-8cff-a722280da11a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-10b8-720a-8cff-a722280da11a",
        "storage_key": "property/6767906449166916/019d08b1-10b8-720a-8cff-a722280da11a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.golden1center.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10987748936193945510&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-1-center",
      "poi_latitude": "38.5802045",
      "poi_longitude": "-121.4996602",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 888-915-4647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxlrBLxM6IARpi8EH3FTfJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_465e8ad2-c656-4b47-bdfd-07845031cd3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Sutter Health Park",
      "poi_type": "Entertainment",
      "poi_address": "400 Ballpark Dr, West Sacramento, CA 95691, USA",
      "poi_short_description": "Outdoor baseball field features regular sports games, concerts & events, with on-site concessions.",
      "poi_long_description": "People say this stadium offers a variety of seating options, including lawn seats, and has a fun atmosphere with fireworks and activities between innings. They highlight the friendly staff, clean facilities, and the opportunity to see both minor and major league baseball games. They also like the convenient parking and easy access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-c199-75ec-9b3f-dd78e95b7faa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-c199-75ec-9b3f-dd78e95b7faa",
        "storage_key": "property/6767906449166916/019d08b1-c199-75ec-9b3f-dd78e95b7faa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sutterhealthpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2722204505153287407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutter-health-park",
      "poi_latitude": "38.5798114",
      "poi_longitude": "-121.5147519",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-376-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-ef57-76c0-9276-3087abb57f59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-ef57-76c0-9276-3087abb57f59",
        "storage_key": "property/6767906449166916/019d08b1-ef57-76c0-9276-3087abb57f59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnalemcrWmoAR7zShF5M2xyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e80b0166-9e67-47de-b001-0ad6292d3f9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Sacramento Zoo",
      "poi_type": "Entertainment",
      "poi_address": "3930 W Land Park Dr, Sacramento, CA 95822, USA",
      "poi_short_description": "Longtime, 14-acre animal park housing native & endangered species, plus a giraffe encounter exhibit.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including big cats, red pandas, and flamingos, and provides opportunities for giraffe feeding and a carousel ride. They also highlight the active animals, well-maintained habitats, and the friendly and knowledgeable staff.\n\nOther reviews mention the zoo can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-1762-756f-9ce6-fd81e992a9cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-1762-756f-9ce6-fd81e992a9cf",
        "storage_key": "property/6767906449166916/019d08b1-1762-756f-9ce6-fd81e992a9cf.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://saczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6430915052866730629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-zoo",
      "poi_latitude": "38.5392791",
      "poi_longitude": "-121.5040041",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-808-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0nl36XRmoARhXrVCiszP1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_165e810d-fe04-4707-a600-7fd6ae5f8656",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "California State Railroad Museum",
      "poi_type": "Entertainment",
      "poi_address": "125 I St, Sacramento, CA 95814, USA",
      "poi_short_description": "Colorful museum documenting railroad history via vintage locomotives, exhibits & rides.",
      "poi_long_description": "People say this rail museum offers a collection of locomotives, train cars, and model trains, as well as interactive exhibits and a play area. They highlight the intimate setting, beautiful candlelight concerts, and the friendly and knowledgeable staff and volunteers. They also like the informative signs and the opportunity to explore inside some of the train cars. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-0cde-708d-b3a7-86bebe7fdc65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-0cde-708d-b3a7-86bebe7fdc65",
        "storage_key": "property/6767906449166916/019d08b1-0cde-708d-b3a7-86bebe7fdc65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.californiarailroad.museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13064911033240821480&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-railroad-museum",
      "poi_latitude": "38.5849368",
      "poi_longitude": "-121.5044161",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-323-9280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-5fc8-76f2-ae51-99d525326bf3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-5fc8-76f2-ae51-99d525326bf3",
        "storage_key": "property/6767906449166916/019d08b1-5fc8-76f2-ae51-99d525326bf3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJYxCsn83WmoAR6J5mJl3jT7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e3c08e48-377c-481c-b1fe-46ac02498704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "California State Capitol Museum",
      "poi_type": "Entertainment",
      "poi_address": "1315 10th St, Sacramento, CA 95814, USA",
      "poi_short_description": "Elegant, long-standing museum documenting the history of California via exhibits, artifacts & more.",
      "poi_long_description": "Visitors say this history museum offers free tours, a gift shop, and impressive architecture. They also highlight the knowledgeable and friendly tour guides, and the clean and well-maintained building and grounds.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.capitolmuseum.ca.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=378875291323442389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-capitol-museum",
      "poi_latitude": "38.5765882",
      "poi_longitude": "-121.4932368",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-324-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-5fc8-76f2-ae51-99d525326bf3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-5fc8-76f2-ae51-99d525326bf3",
        "storage_key": "property/6767906449166916/019d08b1-5fc8-76f2-ae51-99d525326bf3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJldtsqgTWmoAR1aSB8REJQgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_285ffcce-60aa-4148-bc5c-ced958ca2cd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1020 7th St, Sacramento, CA 95814, USA",
      "poi_short_description": "Spacious fitness center with cardio machines, weight areas, basketball courts and a pool.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including cardio machines, free weights, and a basketball court, as well as amenities like a sauna, steam room, and hot tub. They also highlight the convenient parking, the welcoming and friendly staff, and the positive and uplifting atmosphere.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-c34d-7240-95b7-3299cfa9ffe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-c34d-7240-95b7-3299cfa9ffe2",
        "storage_key": "property/6767906449166916/019d08b1-c34d-7240-95b7-3299cfa9ffe2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/sacramento-ca/downtown-sacramento-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=4640322691779290524&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.5808218",
      "poi_longitude": "-121.4983842",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-658-1626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQN3eyzRmoARnGWwFue8ZUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_03326a85-5dee-432f-886b-9b5eebc42ac4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4750 Natomas Blvd, Sacramento, CA 95835, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of machines and equipment, including cardio, resistance training, and free weights. They also highlight the clean and well-maintained facilities, and the friendly and helpful staff.\n\nOther reviews mention it can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-c335-75bd-8ad1-e0843577416c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-c335-75bd-8ad1-e0843577416c",
        "storage_key": "property/6767906449166916/019d08b1-c335-75bd-8ad1-e0843577416c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/natomas-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=14646428136180834555&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.659707",
      "poi_longitude": "-121.5095647",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-857-8630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp9tzs3wpm4AR-2BYLcqQQss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a0505b54-8e05-496c-9b2c-a13e5547725d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "In-Shape Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3880 Innovator Dr, Sacramento, CA 95834, USA",
      "poi_short_description": "Family-friendly fitness center offering an indoor and outdoor pool plus a kids' zone and climbing wall.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, indoor and outdoor pools, and a kids' splash area.\n\nOther reviews mention the facilities can be poorly maintained and some machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-24f4-736c-9bac-89a98e11f9d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-24f4-736c-9bac-89a98e11f9d8",
        "storage_key": "property/6767906449166916/019d08b1-24f4-736c-9bac-89a98e11f9d8.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.inshape.com/gyms/natomas?utm_source=G&utm_medium=Local&utm_campaign=Google-Local&utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1974938444105111114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-shape-fitness",
      "poi_latitude": "38.639569",
      "poi_longitude": "-121.5083534",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-239-4455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSiAMj_WmoARStYlHg1kaBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6687e900-0ced-417d-a8dd-92ca27930140",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "City Sports Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3580 Crocker Dr, Sacramento, CA 95818, USA",
      "poi_short_description": "",
      "poi_long_description": "Some gym goers say this gym offers a wide variety of well-maintained machines, a clean facility, and friendly, helpful staff. \n\nOther reviews mention the gym can be crowded and membership cancellation can be difficult.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.citysportsfitness.com/Pages/clubhome.aspx?clubid=1312&",
      "poi_directions_map_url": "https://maps.google.com/?cid=13663868868192490960&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-sports-club",
      "poi_latitude": "38.54227789999999",
      "poi_longitude": "-121.4838807",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-246-1636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJffwWZuPRmoAR0NUhYlfQn70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8c0f37a9-66c1-4803-aa2c-516d2c35004f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Crunch Fitness - Market Square",
      "poi_type": "Health and Wellness",
      "poi_address": "1739 Arden Way, Sacramento, CA 95815, USA",
      "poi_short_description": "Membership-only gym at Market Square at Arden Fair offering group classes and personal trainers.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and classes. They also highlight the clean facilities, friendly staff, and welcoming atmosphere.\n\nOther reviews mention the membership can be difficult to cancel.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.crunch.com/locations/marketsquare",
      "poi_directions_map_url": "https://maps.google.com/?cid=17728157417301185125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---market-square",
      "poi_latitude": "38.5994681",
      "poi_longitude": "-121.4232353",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-913-2260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZ8uG_3bmoARZZJxRD4RB_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7771916f-4364-4f13-bb6b-e0cbce1754ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Sacramento Central YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2021 W St, Sacramento, CA 95818, USA",
      "poi_short_description": "Community fitness center with a swimming pool and classes, plus programs for children.",
      "poi_long_description": "People say this gym offers a variety of workout equipment, group exercise classes, and a large, heated indoor pool. They also highlight the friendly and helpful staff, the welcoming and inclusive atmosphere, and the clean facilities.\n\nOther reviews mention the facilities can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-c65e-7153-8b86-5cab45867421.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-c65e-7153-8b86-5cab45867421",
        "storage_key": "property/6767906449166916/019d08b1-c65e-7153-8b86-5cab45867421.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "http://www.ymcasuperiorcal.org/sacramentoymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=5417990014250751205&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-central-ymca",
      "poi_latitude": "38.5623639",
      "poi_longitude": "-121.4855257",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-452-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTUhHi-PQmoAR5ZQHVDaRMEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_22e008eb-b8e6-4550-af3b-47264adc2224",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Fitness System",
      "poi_type": "Health and Wellness",
      "poi_address": "2531 Evergreen Ave, West Sacramento, CA 95691, USA",
      "poi_short_description": "Clean fitness center featuring cardio machines, weights and weightlifting equipment.",
      "poi_long_description": "People say this gym has a wide variety of equipment and is open 24 hours. They also highlight the friendly and helpful staff who go the extra mile to assist customers.\n\nSome reviews mention the account cancellation process can be inconvenient.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-c9b5-7512-88e0-1a3d3af20d5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-c9b5-7512-88e0-1a3d3af20d5e",
        "storage_key": "property/6767906449166916/019d08b1-c9b5-7512-88e0-1a3d3af20d5e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://fitnesssystemhealthclubs.com/locations/gym-in-west-sacramento-ca?utm_source=google&utm_medium=gmb&utm_campaign=gmb_listings&utm_content=west_sacramento",
      "poi_directions_map_url": "https://maps.google.com/?cid=11564238311494912985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-system",
      "poi_latitude": "38.5766337",
      "poi_longitude": "-121.5453795",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-371-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV5phVwTUmoAR2QuebnltfKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_70096256-be80-48d2-bfb5-e8575f107514",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "3591 N Freeway Blvd, Sacramento, CA 95834, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-c9c2-71e5-b9f0-e30997371c41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-c9c2-71e5-b9f0-e30997371c41",
        "storage_key": "property/6767906449166916/019d08b1-c9c2-71e5-b9f0-e30997371c41.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/sacramento-ca-189",
      "poi_directions_map_url": "https://maps.google.com/?cid=3579456942113057783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "38.6410428",
      "poi_longitude": "-121.4996954",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-285-6450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkbl0OjbWmoAR92t0wx_JrDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_5ead7502-46d2-4ca6-94d2-48f73595ad78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "UC Davis Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4301 X St, Sacramento, CA 95817, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-1af4-76af-a633-0a6026b6292e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-1af4-76af-a633-0a6026b6292e",
        "storage_key": "property/6767906449166916/019d08b1-1af4-76af-a633-0a6026b6292e.webp",
        "width": 500,
        "height": 330
      },
      "poi_business_url": "https://health.ucdavis.edu/medicalcenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8899362877471555770&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uc-davis-medical-center",
      "poi_latitude": "38.5547656",
      "poi_longitude": "-121.4552827",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 916-734-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-665a-746f-9513-0d06ca30d687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-665a-746f-9513-0d06ca30d687",
        "storage_key": "property/6767906449166916/019d08b1-665a-746f-9513-0d06ca30d687.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJA4rq2nzQmoARuoD93mLjgHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_81c222c5-b943-46dc-879e-7adc6dcb3b0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Mercy General Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4001 J St, Sacramento, CA 95819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-cd7d-717a-9f08-06648efb3456.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-cd7d-717a-9f08-06648efb3456",
        "storage_key": "property/6767906449166916/019d08b1-cd7d-717a-9f08-06648efb3456.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.dignityhealth.org/mercy-general-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=7368210846584852456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-general-hospital",
      "poi_latitude": "38.5706208",
      "poi_longitude": "-121.4528939",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-453-4545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-665a-746f-9513-0d06ca30d687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-665a-746f-9513-0d06ca30d687",
        "storage_key": "property/6767906449166916/019d08b1-665a-746f-9513-0d06ca30d687.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJcQNtDZvQmoAR6M_e_LkkQWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_77c8dd10-6c8c-46d9-8831-c1cd3ae9c73b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Discovery Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Sacramento, CA 95833, USA",
      "poi_short_description": "302-acre park featuring a 32-mile bike trail, ball fields, picnic sites, fishing & boat launches.",
      "poi_long_description": "People say this park offers a boat launch, fishing, and picnic areas with barbecue grills and shade. They also highlight the spacious layout, the American River bike trail, and the beautiful views of the river confluence.\n\nSome reviews mention the park can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-06f8-7218-8d9b-13b9e5178523.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-06f8-7218-8d9b-13b9e5178523",
        "storage_key": "property/6767906449166916/019d08b1-06f8-7218-8d9b-13b9e5178523.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://regionalparks.saccounty.net/Parks/Pages/DiscoveryPark.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6608359273538838528&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "discovery-park",
      "poi_latitude": "38.6057626",
      "poi_longitude": "-121.50348",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-875-6961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-5f85-7388-9c58-9c2a09574b1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-5f85-7388-9c58-9c2a09574b1b",
        "storage_key": "property/6767906449166916/019d08b1-5f85-7388-9c58-9c2a09574b1b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqjbDmoARAOBwJ7-btVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3ca50ef8-4714-466b-aa5e-0c284918c3a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "McKinley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 Alhambra Blvd, Sacramento, CA 95816, USA",
      "poi_short_description": "Relaxing preserve featuring a rose garden, seasonal pool, playgrounds, tennis courts & trails.",
      "poi_long_description": "Visitors say this park offers a relaxing atmosphere with a beautiful rose garden, perfect for long walks or jogs, and a pond where you can feed the ducks. They also highlight the well-maintained park, spacious for picnics, and fun for kids with a large playground and a nearby public pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-d010-71d9-9277-eec81e9afdb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-d010-71d9-9277-eec81e9afdb8",
        "storage_key": "property/6767906449166916/019d08b1-d010-71d9-9277-eec81e9afdb8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofsacramento.org/ParksandRec/Parks/Park-Directory/Central-City/McKinley-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9817515343663866372&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mckinley-park",
      "poi_latitude": "38.5768935",
      "poi_longitude": "-121.4630764",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-808-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-5f85-7388-9c58-9c2a09574b1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-5f85-7388-9c58-9c2a09574b1b",
        "storage_key": "property/6767906449166916/019d08b1-5f85-7388-9c58-9c2a09574b1b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb6sj4JfQmoARBCIIjDDSPog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_783b555e-fec7-4ec7-a59b-b5548d96984a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Haggin Oaks Golf Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3645 Fulton Ave, Sacramento, CA 95821, USA",
      "poi_short_description": "Historic golf complex featuring 2 18-hole courses, plus a driving range, a pro shop & an eatery.",
      "poi_long_description": "People say this golf course offers quality lessons, clean and well-maintained courses, and a huge driving range. They highlight the late-night driving range and food trucks, and the enjoyable experience of hitting balls and dining at the MacKenzie Grill. They also like the instructors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-cf68-71f2-ab52-71246bd1e7cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-cf68-71f2-ab52-71246bd1e7cb",
        "storage_key": "property/6767906449166916/019d08b1-cf68-71f2-ab52-71246bd1e7cb.webp",
        "width": 996,
        "height": 657
      },
      "poi_business_url": "https://www.hagginoaks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6467797662234953962&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haggin-oaks-golf-complex",
      "poi_latitude": "38.633561",
      "poi_longitude": "-121.4033421",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-808-2515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-f232-73cc-8ace-5057a74573dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-f232-73cc-8ace-5057a74573dd",
        "storage_key": "property/6767906449166916/019d08b1-f232-73cc-8ace-5057a74573dd.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJz69Jx6HZmoAR6siduLQ7wlk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_d292d75f-b4b0-4e74-99bd-6b3a0c6f00c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "California State Capitol Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 L St, Sacramento, CA 95814, USA",
      "poi_short_description": "Scenic city green space with monuments, memorials, flower gardens & walking paths.",
      "poi_long_description": "People say this park offers beautiful gardens, exotic trees, and historic monuments, including a rose garden and memorials to veterans and firefighters. They highlight the peaceful and relaxing vibe, and the well-maintained grounds with clear signage. They also like that the park is dog-friendly and provides opportunities for learning about botany and history. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-cfda-77e0-a417-270f7107e07a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-cfda-77e0-a417-270f7107e07a",
        "storage_key": "property/6767906449166916/019d08b1-cfda-77e0-a417-270f7107e07a.webp",
        "width": 640,
        "height": 853
      },
      "poi_business_url": "https://capitolmuseum.ca.gov/learn/about-the-capitol/capitol-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5243745298811035407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-capitol-park",
      "poi_latitude": "38.5759282",
      "poi_longitude": "-121.4907022",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-324-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-5f85-7388-9c58-9c2a09574b1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-5f85-7388-9c58-9c2a09574b1b",
        "storage_key": "property/6767906449166916/019d08b1-5f85-7388-9c58-9c2a09574b1b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuVIWBdjQmoARD59BFJGGxUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8e1d2c4b-627b-4814-bd48-c7e4a3ba3339",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "State Capitol Park World Peace Rose Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1317 15th St, Sacramento, CA 95814, USA",
      "poi_short_description": "Peace-themed Victorian style rose garden within a park, with a fountain & pavilion.",
      "poi_long_description": "Visitors say this rose garden offers a tranquil experience with hundreds of varieties of roses in bloom, as well as trees from all over the world. They also highlight the well-maintained park, peaceful atmosphere, and educational value of the different rose species.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-d4ed-753c-bad5-57a82309f22c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-d4ed-753c-bad5-57a82309f22c",
        "storage_key": "property/6767906449166916/019d08b1-d4ed-753c-bad5-57a82309f22c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://worldpeacerosegardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1381262157938595809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "state-capitol-park-world-peace-rose-garden",
      "poi_latitude": "38.575501",
      "poi_longitude": "-121.4883327",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-381-5433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-5f85-7388-9c58-9c2a09574b1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-5f85-7388-9c58-9c2a09574b1b",
        "storage_key": "property/6767906449166916/019d08b1-5f85-7388-9c58-9c2a09574b1b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_Yds9nQmoAR4ZeeSZ06KxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_65fbb686-8e95-48b2-9a5a-72db3e7877ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Sacramento Valley Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-d84a-716f-a52a-418a16cc396c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-d84a-716f-a52a-418a16cc396c",
        "storage_key": "property/6767906449166916/019d08b1-d84a-716f-a52a-418a16cc396c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6346517780329793861&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-valley-station-wb",
      "poi_latitude": "38.584627",
      "poi_longitude": "-121.500439",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncYA5dLWmoARRQlCwUtcE1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_fe5ad41f-0c0c-45d5-bfe8-7419eb7b4634",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Arden/Del Paso Station (EB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95815, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-d811-718a-a169-d5ecc1e28d56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-d811-718a-a169-d5ecc1e28d56",
        "storage_key": "property/6767906449166916/019d08b1-d811-718a-a169-d5ecc1e28d56.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=567876029887657118&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ardendel-paso-station-eb",
      "poi_latitude": "38.606207",
      "poi_longitude": "-121.456274",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd59FpVrXmoARnrTpjT2A4Qc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_0592f0a8-50b0-4127-8b7f-a6c4e84de60a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "7th & Capitol",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-d992-76bb-a6e1-fcbfd116fb7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-d992-76bb-a6e1-fcbfd116fb7e",
        "storage_key": "property/6767906449166916/019d08b1-d992-76bb-a6e1-fcbfd116fb7e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5048847390555747041&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "7th--capitol",
      "poi_latitude": "38.5783062",
      "poi_longitude": "-121.4989023",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTq-mS7RmoAR4bI7p_MbEUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_38eaec3b-ae44-4f3d-a969-7439ec062a7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "16th Street Station (EB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95811, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-dcc5-70d3-9eeb-3c45fda267b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-dcc5-70d3-9eeb-3c45fda267b7",
        "storage_key": "property/6767906449166916/019d08b1-dcc5-70d3-9eeb-3c45fda267b7.webp",
        "width": 1280,
        "height": 806
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4554807020176890849&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "16th-street-station-eb",
      "poi_latitude": "38.5697554",
      "poi_longitude": "-121.4891647",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJowcyqN_QmoAR4VsZOtrsNT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_19cd2a90-9bf2-4ba3-898d-f293460f0587",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "St. Rose of Lima Park ( 9th & K )",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-dfab-732f-b714-ee287bfad049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-dfab-732f-b714-ee287bfad049",
        "storage_key": "property/6767906449166916/019d08b1-dfab-732f-b714-ee287bfad049.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3232408438487941295&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-rose-of-lima-park--9th--k-",
      "poi_latitude": "38.5795637",
      "poi_longitude": "-121.495492",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9nzYCnRmoARr4AMSVnS2yw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_a520bd2e-67ed-418e-b23e-c9f83349c0d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Sacramento City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "915 I St, Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-df9f-71ab-b0bc-dbe99f439cf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-df9f-71ab-b0bc-dbe99f439cf8",
        "storage_key": "property/6767906449166916/019d08b1-df9f-71ab-b0bc-dbe99f439cf8.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.cityofsacramento.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5261544109164931557&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-city-hall",
      "poi_latitude": "38.5823421",
      "poi_longitude": "-121.4933431",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-264-5011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-6a9c-723f-936d-50f656e1e49e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-6a9c-723f-936d-50f656e1e49e",
        "storage_key": "property/6767906449166916/019d08b1-6a9c-723f-936d-50f656e1e49e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9NSRSrRmoAR5SnTjH3CBEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_a4ecf230-ea9c-4521-a0f4-8f546dbefd5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Blue Diamond Growers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1802 C St, Sacramento, CA 95811, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-e2b8-7049-9921-37fba458dbf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-e2b8-7049-9921-37fba458dbf9",
        "storage_key": "property/6767906449166916/019d08b1-e2b8-7049-9921-37fba458dbf9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bluediamondgrowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16247972805344263985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-diamond-growers",
      "poi_latitude": "38.5857959",
      "poi_longitude": "-121.4810041",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-442-0771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7CwctLQmoARMX_AVi5lfOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_100ce166-a87a-49a1-93a1-d68906c9bd3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "City of West Sacramento City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1110 W Capitol Ave, West Sacramento, CA 95691, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-e50f-72fa-9c87-d86bdf8c4ca5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-e50f-72fa-9c87-d86bdf8c4ca5",
        "storage_key": "property/6767906449166916/019d08b1-e50f-72fa-9c87-d86bdf8c4ca5.webp",
        "width": 1280,
        "height": 808
      },
      "poi_business_url": "http://www.cityofwestsacramento.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5233966858684488344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-west-sacramento-city-hall",
      "poi_latitude": "38.58203210000001",
      "poi_longitude": "-121.5234091",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-617-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-6a9c-723f-936d-50f656e1e49e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-6a9c-723f-936d-50f656e1e49e",
        "storage_key": "property/6767906449166916/019d08b1-6a9c-723f-936d-50f656e1e49e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcUyoorHWmoARmFoOkiDJokg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_57a453c4-4867-4a1d-9ba5-f2ece0325e90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Resources Building - State of California",
      "poi_type": "Major Employers & Offices",
      "poi_address": "715 P St, Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-e644-7559-af6f-acb6e4d3ffe1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-e644-7559-af6f-acb6e4d3ffe1",
        "storage_key": "property/6767906449166916/019d08b1-e644-7559-af6f-acb6e4d3ffe1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://resources.ca.gov/About-Us/our-new-headquarters",
      "poi_directions_map_url": "https://maps.google.com/?cid=13310981311370573820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "resources-building---state-of-california",
      "poi_latitude": "38.5752007",
      "poi_longitude": "-121.4993404",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-367-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH9oPNi_RmoAR_DcbZPoaurg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_28acae90-5b6a-4e43-a736-43bea4600ce3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "poi_name": "Centene Campus Natomas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4201 E Commerce Way, Sacramento, CA 95834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-e696-7695-b172-8f974228e1e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-e696-7695-b172-8f974228e1e1",
        "storage_key": "property/6767906449166916/019d08b1-e696-7695-b172-8f974228e1e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.centene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9616052681257976114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "centene-campus-natomas",
      "poi_latitude": "38.6466286",
      "poi_longitude": "-121.5240407",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 314-725-4477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-600f-70fb-b56b-489198c4059d",
        "storage_key": "property/6767906449166916/019d08b1-600f-70fb-b56b-489198c4059d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaddcK4jXmoARMgHTL_cUc4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_22bfef81-698e-433e-8760-177f92551722",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_e37d167e-6622-4375-aaeb-c0114725f7d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_0a3d99f9-6f30-4de3-91d9-8c3e0297eb15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_508d671e-54cc-4c42-99e2-3c723619eb0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_e818e493-afab-4cfa-8cc2-e5842e1c95fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_8715eb3f-7963-48f4-bd17-61a62f96908b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_c2cf063f-36fa-4349-8fd3-f261ae6dafff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "rating": "5.0",
      "name": "Aurora Carlson",
      "text": "I hardly have a compliant about the apartment environment. So when I have a question or comment, I email or note it in the app. It is always addressed promptly and courteously by management or maintenance staff. Whenever I hear renters complain about their apartments, I can feel bad for them. But I always express that at Woodbridge that is never an issue; we are well managed by attentive, professional, caring people! Moving here was the best housing decision I ever made.",
      "date": "2025-05-05",
      "title": ""
    },
    {
      "id": "custom_156bdb66-dad6-4b62-9cf9-0356689b5ba6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "rating": "5.0",
      "name": "Paxtenne Falls-Giese",
      "text": "I've lived here for a few months now and I absolutely love it. I love the washer and dryer in every unit (it even comes in its own little enclosed area) and I love the 24 hour accessible fitness room. I think the whole complex is so beautiful and perfectly placed so it's right next to a bunch of stores, and the freeway. I'm very happy here.",
      "date": "2017-12-13",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e865042d-a2af-4b73-9d7c-41fae68192a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d316e-92a9-752d-b282-1cefde15b20c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d316e-92a9-752d-b282-1cefde15b20c",
        "storage_key": "property/6767906449166916/019d316e-92a9-752d-b282-1cefde15b20c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Woodbridge Apartments - 1 Bedroom 1 Bath 655 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bvBMYFYVG5K"
    },
    {
      "id": "custom_78d23e03-a81b-4fc2-b55b-03264b8d2539",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d316e-a65e-75dd-9021-73b80763941b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d316e-a65e-75dd-9021-73b80763941b",
        "storage_key": "property/6767906449166916/019d316e-a65e-75dd-9021-73b80763941b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Woodbridge Apartments - 2 Bedroom 2 Bath 875 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Q4xCbdRUQDF"
    },
    {
      "id": "custom_e9cf7acf-7a72-4bd6-aeb2-2267432af106",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d316e-b7f0-719b-93a1-08f8e19632c6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d316e-b7f0-719b-93a1-08f8e19632c6",
        "storage_key": "property/6767906449166916/019d316e-b7f0-719b-93a1-08f8e19632c6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Woodbridge Apartments - 2 Bedroom 1 Bath 765 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hfZYK5NzzbD"
    },
    {
      "id": "custom_047aafa9-360d-47f1-a2eb-3fde5d57f092",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d316e-cb62-76f5-b6b5-547d287e5538.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d316e-cb62-76f5-b6b5-547d287e5538",
        "storage_key": "property/6767906449166916/019d316e-cb62-76f5-b6b5-547d287e5538.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Woodbridge Apartments - Pool & Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DUVHbUbQ4pk"
    },
    {
      "id": "custom_7a62e03f-998e-4927-8edd-49ff4f9a01ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d316e-dd57-77f0-85b8-9baabe5b74c6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d316e-dd57-77f0-85b8-9baabe5b74c6",
        "storage_key": "property/6767906449166916/019d316e-dd57-77f0-85b8-9baabe5b74c6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Woodbridge Apartments - Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1QgrkccsasR"
    },
    {
      "id": "custom_833e6db3-094e-4138-98bc-97985f08ce65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d316e-f28d-724a-9b1a-c312d0a93c4d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d316e-f28d-724a-9b1a-c312d0a93c4d",
        "storage_key": "property/6767906449166916/019d316e-f28d-724a-9b1a-c312d0a93c4d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Woodbridge Apartments - Outdoor Playground",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=avsMbpjXwNQ"
    },
    {
      "id": "custom_42e83c1a-1872-4064-82b9-cf31bae44880",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166916/019d316f-0924-76ae-a857-a3c58a63ecc5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d316f-0924-76ae-a857-a3c58a63ecc5",
        "storage_key": "property/6767906449166916/019d316f-0924-76ae-a857-a3c58a63ecc5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Woodbridge Apartments - Welcome Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zBUoZdz6LkE"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db14c-3ef4-772f-9568-5401a3d175b2",
      "lead_source": "LANDING_PAGE",
      "name": "Woodbridge Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "generator",
      "page_item_url": "pool-apartments-north-sacramento",
      "search_query": "pool apartments in North Sacramento",
      "category": "Amenity",
      "h1_title": "Pool Apartments in North Sacramento",
      "h2_subtitle": "Discover the perfect poolside living at Woodbridge Apartments. Nestled in North Sacramento, enjoy our community with amenities designed for relaxation.",
      "page_copy": "Located in the heart of North Sacramento, Woodbridge Apartments offers an inviting community experience with its beautifully maintained pool. Perfect for social gatherings or private relaxation, the pool is just one of the many amenities available to our residents. Whether you want to host a picnic in the designated area, enjoy a game on the tennis court, or let the kids play on the playground, you'll find Woodbridge is more than just a place to live – it's a place to thrive.\n\nOur North Sacramento location provides easy access to local attractions and city convenience, making it a prime spot for those who seek a vibrant lifestyle. Each apartment comes equipped with a washer and dryer, ensuring comfortable and convenient living. Come and explore how life at Woodbridge Apartments, the premier choice for pool apartments in North Sacramento, can enhance your everyday life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in North Sacramento",
      "seo_description": "Explore poolside living at Woodbridge Apartments in North Sacramento. Relax and unwind with top amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-sacramento",
      "search_query": "fitness center apartments Sacramento",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Sacramento",
      "h2_subtitle": "Experience a healthy lifestyle at Woodbridge Apartments. Although we don't have a fitness center, our community amenities in Sacramento offer plenty of activities.",
      "page_copy": "While Woodbridge Apartments may not feature an on-site fitness center, our Sacramento community provides plenty of opportunities to stay active and healthy. Enjoy a match on our tennis court, or spend some time outdoors at our playground and picnic area. The nearby local gyms and fitness centers also offer residents convenient access to exceptional exercise facilities.\n\nSet in a vibrant part of Sacramento, Woodbridge Apartments ensures that convenience is key, with amenities like a washer/dryer in each apartment, a community playground, and sprawling picnic areas. Situated in North Sacramento, you can enjoy the best of both indoor and outdoor living. Discover how Woodbridge Apartments can become your ideal home base for an active Sacramento lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Sacramento",
      "seo_description": "Stay active at Woodbridge Apartments in Sacramento! Enjoy our amenities or explore nearby fitness centers for a healthy lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "generator",
      "page_item_url": "apartments-with-views-sacramento-ca",
      "search_query": "apartments with views Sacramento CA",
      "category": "Amenity",
      "h1_title": "Apartments with Views Sacramento, CA",
      "h2_subtitle": "Discover scenic views at Woodbridge Apartments. Nestled in Sacramento, CA, enjoy our community's tranquil and picturesque surroundings.",
      "page_copy": "Woodbridge Apartments in Sacramento, CA, offer residents more than just a place to live; they provide a window to beautiful surroundings with serene views. Our community is thoughtfully designed to maximize open spaces, ensuring that you can enjoy the lush greenery and peaceful ambiance from the comfort of your apartment. The picnic area offers a perfect spot to unwind while taking in the scenic beauty around you.\n\nConveniently located in Sacramento, Woodbridge Apartments are the ideal choice for those seeking both tranquility and city accessibility. The community amenities including a tennis court and playground add to the appeal, offering residents varied options for recreation and leisure. Choose Woodbridge Apartments as your haven in Sacramento, and experience life enhanced by beautiful views and exceptional convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Views Sacramento, CA",
      "seo_description": "Enjoy scenic views at Woodbridge Apartments in Sacramento, CA. Delight in tranquil surroundings and explore vibrant city life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "generator",
      "page_item_url": "washer-dryer-apartments-95833",
      "search_query": "washer dryer apartments in 95833",
      "category": "Amenity",
      "h1_title": "Washer Dryer Apartments in 95833",
      "h2_subtitle": "Find convenience with in-unit washers and dryers at Woodbridge Apartments. Located in the 95833 area, experience a hassle-free lifestyle.",
      "page_copy": "Woodbridge Apartments in Sacramento's 95833 area offers the perfect blend of comfort and convenience with in-unit washers and dryers. Say goodbye to the hassle of communal laundry rooms and enjoy the ease of doing laundry right in your own home. This feature is part of what makes living at Woodbridge a truly comfortable and modern experience.\n\nSituated in North Sacramento, our community is enriched with amenities including a playground, a picnic area, and a tennis court, allowing residents to enjoy both indoor and outdoor activities. At Woodbridge Apartments, convenience meets quality, ensuring that your daily living needs are met with ease. Explore how life in the sought-after 95833 area can be stress-free and enjoyable at Woodbridge Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer Dryer Apartments in 95833",
      "seo_description": "Woodbridge Apartments in Sacramento's 95833 area offers in-unit washer dryers for hassle-free living. Enjoy convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-sacramento-county",
      "search_query": "smoke free apartments Sacramento County",
      "category": "Amenity",
      "h1_title": "Smoke Free Apartments Sacramento County",
      "h2_subtitle": "Live healthy at Woodbridge Apartments in Sacramento County. Enjoy our smoke-free environment alongside numerous amenities designed for modern living.",
      "page_copy": "At Woodbridge Apartments, located in Sacramento County, we prioritize your health and well-being with our smoke-free policy. This ensures a clean, fresh environment for all residents to enjoy, contributing to a healthier living space for everyone. Nestled in the vibrant area of North Sacramento, our community is dedicated to providing a high-quality lifestyle.\n\nBeyond a smoke-free atmosphere, Woodbridge Apartments offers a variety of amenities to enhance your living experience, including a washer/dryer in each unit, a playground, picnic areas, and a tennis court. Enjoy the best of community living in Sacramento County, where your comfort and satisfaction are our top priorities. Discover the perfect setting at Woodbridge Apartments, where clean air and modern conveniences come together seamlessly.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke Free Apartments Sacramento County",
      "seo_description": "Discover smoke-free living at Woodbridge Apartments in Sacramento County. Enjoy a healthy lifestyle with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-north-sacramento",
      "search_query": "1 bedroom apartments north sacramento",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments North Sacramento",
      "h2_subtitle": "Explore comfortable 1 bedroom apartments at Woodbridge in North Sacramento. Designed for ease and style, our units are perfect for your lifestyle.",
      "page_copy": "Woodbridge Apartments in North Sacramento offers charming 1 bedroom apartments that are perfect for those seeking a blend of comfort and convenience. Our spacious units are designed to provide a modern lifestyle, complete with all the essentials you need. Whether you're a young professional, a student, or someone looking to downsize, our apartments cater to a variety of needs and preferences.\n\nNestled in the heart of North Sacramento, our community boasts a variety of amenities that make living here truly enjoyable. Residents can take advantage of the on-site playground, have a relaxing afternoon at the picnic area, or challenge friends to a game on our tennis court. With in-unit washer/dryer facilities, you can enjoy the convenience of doing laundry at home. Choose Woodbridge Apartments for a quality living experience in Sacramento.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments North Sacramento",
      "seo_description": "Discover 1 bedroom apartments at Woodbridge in North Sacramento. Experience comfort and convenience in a fantastic location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166916",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-95833",
      "search_query": "2 bedroom apartments 95833",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in 95833",
      "h2_subtitle": "Discover spacious 2 bedroom apartments at Woodbridge in the 95833 area. Perfect for families or roommates seeking comfortable living.",
      "page_copy": "Located in the heart of Sacramento's 95833 area, Woodbridge Apartments offers spacious 2 bedroom units ideal for families, roommates, or anyone craving extra space. Our apartments are designed with modern amenities that make living comfortable and convenient, including an in-unit washer/dryer and fully equipped kitchen. These features ensure that all your needs are met within your home.\n\nWoodbridge Apartments also boasts a range of community amenities like a playground perfect for children, a relaxing picnic area, and a tennis court for sports enthusiasts. Situated in the thriving North Sacramento neighborhood, our community provides easy access to local shops, dining, and entertainment. Choose Woodbridge Apartments for a living experience that combines comfort, convenience, and community in the vibrant 95833 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in 95833",
      "seo_description": "Explore spacious 2 bedroom apartments at Woodbridge in the 95833 area. Enjoy comfort and community amenities for a great living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5972"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372416546"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MJLF4R8C"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-604-0393 "
    }
  ],
  "custom_qb_id": "5972",
  "custom_repli_id": "18372416546",
  "custom_google_gtm_id": "GTM-MJLF4R8C",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-604-0393 "
};

export const generatedAt = '2026-09-23T19:54:12.154Z';
